import { FC } from 'react';
import Skeleton from '../../components/layout/Skeleton';

/**
 * Shimmer placeholder for a candidate row's identity/meta content while the
 * ATS `candidatesByIds` hydration call is still in flight (README §Candidate
 * row: "Not-yet-hydrated rows show shimmer skeletons for title/meta ...
 * 'loading profile…'"). The rank/score column is NOT covered here — that
 * data is already present from the list payload and renders immediately
 * (see CandidateRow.tsx, STORY-2A-SPEC rule 6).
 *
 * Reuses the app's existing `components/layout/Skeleton` shimmer primitive
 * (percentage-width bar) rather than hand-rolling a new shimmer animation.
 */
const RowSkeleton: FC = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0, width: '100%' }}>
    <div style={{ width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
      <Skeleton width={100} height={36} />
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ width: 160, marginBottom: 6 }}>
        <Skeleton width={100} height={14} />
      </div>
      <div style={{ width: 210, marginBottom: 6 }}>
        <Skeleton width={100} height={11} />
      </div>
      <div style={{ width: 150, marginBottom: 4 }}>
        <Skeleton width={100} height={11} />
      </div>
      <div style={{ fontSize: 11, color: '#98A2B3', marginTop: 2 }}>loading profile…</div>
    </div>
  </div>
);

export default RowSkeleton;
